import { useEffect, useContext, useState } from 'react'

function CMSContent(props) {
	
	return(
		<div className="container px-4 cms-container" dangerouslySetInnerHTML={{ __html: props.content}}>
		</div>
	);
}
export default CMSContent;